import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

export const BundleServiceHierarchyLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleServiceHierarchy } = await import("@workflows/bundles/configurations/service-hierarchy");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_SERVICE_HIERARCHY}>
      <BundleServiceHierarchy />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
